module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-profile-page"
  }, [_c('div', {
    staticClass: "container edit-user-template"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [(_vm.canEditDetails) ? [_vm._v("\n        Edit my company subscription\n      ")] : [_vm._v("\n        My company subscription\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                    c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                    S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                    C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("Company details")] : [_vm._v("Edit company details")]], 2)]), _vm._v(" "), (_vm.getUserRole === 'ta' || _vm.getUserRole === 'gm') ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 email-endings",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyEmails'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyEmails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 13"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 13",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_8_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_10_",
      "d": "M10,5.823l8.965-5.564C18.678,0.1,18.352,0,18,0H2C1.648,0,1.322,0.1,1.035,0.259L10,5.823z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_9_",
      "d": "M10.527,7.85C10.366,7.95,10.183,8,10,8C9.817,8,9.634,7.95,9.473,7.85l-9.47-5.877\n                      C0.003,1.982,0,1.991,0,2v9c0,1.102,0.897,2,2,2h16c1.103,0,2-0.898,2-2V2c0-0.009-0.003-0.018-0.003-0.027L10.527,7.85z"
    }
  })])])]), _vm._v(" "), (_vm.canEditEmails === false) ? [_vm._v("Approved domains for emails")] : [_vm._v("Edit approved domains for emails")]], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 10 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 10 20",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_2_",
      "cx": "5",
      "cy": "3",
      "r": "3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_3_",
      "d": "M5,6c-2.757,0-5,2.243-5,5v3c0,0.552,0.448,1,1,1h1v4c0,0.552,0.448,1,1,1h4\n                      c0.552,0,1-0.448,1-1v-4h1c0.552,0,1-0.448,1-1v-3C10,8.243,7.757,6,5,6z"
    }
  })])])]), _vm._v(" "), (_vm.canEditOwner === false) ? [_vm._v("Product owner")] : [_vm._v("Edit product owner")]], 2)]), _vm._v(" "), (_vm.getUserRole === 'ca') ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 tasks",
    class: [{
      'active  color-1-100': _vm.activeSection === 'tasksSettings'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "12",
      "viewBox": "0 0 16 12"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M.5-10a.442.442,0,0,1-.5-.5v-1A.442.442,0,0,1,.5-12h13a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5Zm15,3a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H2.5A.442.442,0,0,1,2-5.5v-1A.442.442,0,0,1,2.5-7Zm-2,5a.442.442,0,0,1,.5.5v1a.442.442,0,0,1-.5.5H.5A.442.442,0,0,1,0-.5v-1A.442.442,0,0,1,.5-2Z",
      "transform": "translate(0 12)"
    }
  })])]), _vm._v(" "), (_vm.canEditDetails === false) ? [_vm._v("Tasks settings")] : [_vm._v("Edit tasks settings")]], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(this.tabActive === 'profile') ? [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section profile-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyDetails' || _vm.canEditDetails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Company subscription details")] : [_vm._v("Edit company subscription details")]], 2), _vm._v(" "), (_vm.canEditDetails === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.name),
      expression: "company.details.name"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.company.details.name)
    },
    on: {
      "keyup": _vm.fieldChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta') ? _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": true,
      "searchable": true,
      "options": _vm.preparedCompanies,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.company.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "parent", $$v)
      },
      expression: "company.details.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.getUserRole !== 'ca' && _vm.getUserRole !== 'ta') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company name'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "disabled": _vm.canEditDetails === false,
      "searchable": true,
      "options": _vm.preparedCompanies,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.company.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.company.details, "parent", $$v)
      },
      expression: "company.details.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element form-element-date",
    attrs: {
      "id": "date-selector"
    }
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Subscription ends on:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.subscriptionEnd),
      expression: "company.details.subscriptionEnd"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked",
    class: [{
      'has-error': _vm.errors.has('Subscription ends'),
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.company.details.subscriptionEnd)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "subscriptionEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canEditDetails && _vm.datepicker.shown),
      expression: "canEditDetails && datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.subscription,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event)
      }
    },
    model: {
      value: (_vm.datepicker.subscription),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "subscription", $$v)
      },
      expression: "datepicker.subscription"
    }
  })], 1)]), _vm._v(" "), (this.errors.has('Subscription ends')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subscription ends')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-limit"
    }
  }, [_vm._v("Employee limit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.employeeLimit),
      expression: "company.details.employeeLimit"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-limit",
      "name": "Employee limit"
    },
    domProps: {
      "value": (_vm.company.details.employeeLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "employeeLimit", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Employee limit')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Employee limit')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-language"
    }
  }, [_vm._v("Default language")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.language),
      expression: "company.details.language"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-language",
      "name": "Default language"
    },
    domProps: {
      "value": (_vm.company.details.language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "language", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta') ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-url"
    }
  }, [_vm._v("Company url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.details.url),
      expression: "company.details.url"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'is-locked': !_vm.canEditDetails
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-company-url",
      "name": "Company url"
    },
    domProps: {
      "value": (_vm.company.details.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.details, "url", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), (_vm.getUserRole === 'ta' || _vm.getUserRole === 'gm') ? _c('div', {
    ref: "companyEmails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyEmails' || _vm.canEditEmails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditEmails === false) ? [_vm._v("Approved domains for emails")] : [_vm._v("Edit approved domains for emails")]], 2), _vm._v(" "), (_vm.canEditEmails === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-1000",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditEmails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.company.approvedEmails), function(row, index) {
    return _c('div', {
      staticClass: "form-group form-group-half",
      class: [{
        'form-group-right-item': (index > 0 && (index + 1) % 2 === 0) && _vm.canEditEmails === true,
        'form-group__email-ending-input': _vm.canEditEmails === true
      }]
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((row.email !== '' && _vm.canEditEmails === false) || _vm.canEditEmails === true),
        expression: "(row.email !== '' && canEditEmails === false) || canEditEmails === true"
      }, {
        name: "model",
        rawName: "v-model",
        value: (row.email),
        expression: "row.email"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "disabled": _vm.canEditEmails === false,
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.canEditEmails === true && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
    }, [_c('a', {
      staticClass: "add-email-ending",
      attrs: {
        "href": "#",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeElement(index)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditEmails === true && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "form-group form-group__email-add-button"
  }, [_c('a', {
    staticClass: "add-email-ending",
    attrs: {
      "href": "#",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addEmailRow($event)
      }
    }
  }, [_vm._v("Add new")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditEmails && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditEmails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyEmails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'companyOwner' || _vm.canEditOwner
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOwner === false) ? [_vm._v("Profile information")] : [_vm._v("Edit profile information")]], 2), _vm._v(" "), (_vm.canEditOwner === false && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('a', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOwner()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Account owner first name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.firstName),
      expression: "company.ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.company.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.phoneNumber),
      expression: "company.ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.company.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("Account owner last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.lastName),
      expression: "company.ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.company.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.ownerData.email),
      expression: "company.ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email'),
      'is-locked': !_vm.canEditOwner
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditOwner === false,
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.company.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditOwner && (_vm.getUserRole === 'ca' || _vm.getUserRole === 'ta')) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOwner()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyOwner()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])]), _vm._v(" "), (_vm.getUserRole === 'ca') ? _c('div', {
    ref: "tasksSettings",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'tasksSettings' || _vm.canEditTasksSettings
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditTasksSettings === false) ? [_vm._v("Task settings")] : [_vm._v("Edit tasks settings")]], 2), _vm._v(" "), (_vm.canEditTasksSettings === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openTasksSettings()
      }
    }
  }, [_vm._v("Edit\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.tasksSettings.contraption),
      expression: "company.tasksSettings.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditTasksSettings === false,
      "data-lpignore": "true",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.company.tasksSettings.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company.tasksSettings, "contraption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-default-assignee"
    }
  }, [_vm._v("Default assignee")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Default assignee'),
      'is-locked': !_vm.canEditTasksSettings
    }],
    attrs: {
      "disabled": _vm.canEditTasksSettings === false,
      "searchable": true,
      "options": _vm.defaultAssigneeForSelect,
      "data-vv-name": "Default assignee",
      "data-lpignore": "true",
      "name": "Default assignee",
      "id": "company-default-assignee"
    },
    model: {
      value: (_vm.company.tasksSettings.defaultAssignee),
      callback: function($$v) {
        _vm.$set(_vm.company.tasksSettings, "defaultAssignee", $$v)
      },
      expression: "company.tasksSettings.defaultAssignee"
    }
  }), _vm._v(" "), (this.errors.has('Default assignee')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Default assignee')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditTasksSettings) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditTasksSettings()
      }
    }
  }, [_vm._v("Discard changes\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateCompanyTasksSettings()
      }
    }
  }, [_vm._v("Save changes\n                ")])]) : _vm._e()])]) : _vm._e()] : _vm._e()], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab813cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CompanySubscription.vue
// module id = 944
// module chunks = 1